import { defineMessages } from 'react-intl';

type MessageKeys = 'resizeSideNavLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		resizeSideNavLabel: {
			id: 'ai-mate.rovo-navigation.side-navigation.container.resize',
			defaultMessage: 'Resize side navigation',
			description: 'Label for the side nav panel splitter',
		},
	});

export default message;
